// extracted by mini-css-extract-plugin
module.exports = {"Container":"Switch_Container__23J-y","Switch":"Switch_Switch__3qiHI","Slider":"Switch_Slider__lgFqy","Slider1":"Switch_Slider1__1PUk0"};